import React from "react";
import styled from "styled-components";

import { Button as BAIButton } from "js/Components/Button";
import InfoBanner from "js/Components/InfoBanner";
import { AiIcon } from "js/editor/AiGeneration/AiIcon";
import {
    PresentationLibraryPaneBreadcrumb,
    PresentationLibraryPaneBreadcrumbData,
} from "js/editor/PresentationLibrary/components/PresentationLibraryPaneBreadcrumb";
import { t } from "js/i18n";

type PresentationLibraryMobileIntroProps = {
    breadcrumb?: PresentationLibraryPaneBreadcrumbData | null;
    onCloseInfoBanner: () => void;
    onCreateWithAi: () => void;
    showCreateWithAiButton: boolean;
    showInfoBanner: boolean;
};

const ButtonContent = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const StyledBAIButton = styled(BAIButton)`
    height: auto;
    width: 100%;
    padding: 4px 12px;

    span {
        padding: 6px 0;
        gap: 10px;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

const InfoBannerContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px 20px 0 20px;
`;

export function PresentationLibraryMobileIntro({
    breadcrumb,
    onCloseInfoBanner,
    onCreateWithAi,
    showCreateWithAiButton,
    showInfoBanner,
}: PresentationLibraryMobileIntroProps) {
    return (
        <InfoBannerContainer data-testid="mobile-library-info">
            {showInfoBanner && (
                <div>
                    <InfoBanner
                        bodyText={t("Create with AI to get started. Switch to desktop to edit and make it your own.")}
                        onClose={onCloseInfoBanner}
                    />
                </div>
            )}
            {!window.isZoomApp && breadcrumb && (
                <div data-testid="mobile-library-breadcrumb-container">
                    <PresentationLibraryPaneBreadcrumb {...breadcrumb} />
                </div>
            )}
            {showCreateWithAiButton && (
                <StyledBAIButton
                    large
                    ai
                    onClick={onCreateWithAi}
                >
                    <ButtonContent>
                        <AiIcon />
                        {t("Create Presentation with AI...")}
                    </ButtonContent>
                </StyledBAIButton>
            )}
        </InfoBannerContainer>
    );
}
